__turbopack_context__.v({
  "activeTabHeader": "Tab-module-scss-module__OIUWGW__activeTabHeader",
  "bottomBorder": "Tab-module-scss-module__OIUWGW__bottomBorder",
  "tabContainer": "Tab-module-scss-module__OIUWGW__tabContainer",
  "tabHeader": "Tab-module-scss-module__OIUWGW__tabHeader",
  "tabHeaders": "Tab-module-scss-module__OIUWGW__tabHeaders",
  "underline": "Tab-module-scss-module__OIUWGW__underline",
});
